<script>
	import { dev } from '$app/environment';
	import { Drawer, Button } from 'svelte-ux';
	import { reportPreviewTag, adminToggleCurrentPage } from '$lib/store/stores.js';
	export let data = [];
	let rightOpen = false;
</script>

{#if dev}
	<Drawer
		bind:open={rightOpen}
		placement="right"
		class="w-[400px] opacity-90"
		classes={{ backdrop: ' bg-black/20' }}
	>
		<h1>Contents</h1>
		<pre class=" z-10 bg-yellow-200 px-5 rounded text-xs opacity-80 w-96 overflow-auto">
			<div class="text-[10px] leading-[10px]">{JSON.stringify(data, null, 4)}</div>
			<div>reportPreviewTag: {$reportPreviewTag}</div>
			<div>Admin current link: {$adminToggleCurrentPage}</div>
		</pre>
		<div
			class="fixed bottom-0 w-full flex justify-center
		  p-1 border-t border-gray-400"
		>
			<slot />
			<Button on:click={() => (rightOpen = false)}>Close</Button>
		</div>
		<hr />
	</Drawer>
	<Button on:click={() => (rightOpen = true)} class="bg-red-300 fixed right-5 bottom-96 z-50"
		>DEBUG</Button
	>
{/if}
